import React from 'react'
import styled from 'styled-components'
import { MobergFontFamily } from '../MobergFont/MobergFont'
import { MdClose } from 'react-icons/md'
import { useDisplayOptimality } from '../../Hooks/useDisplayOptimality'
import { ZoomResolutionContent } from './ZoomResolutionContent'

const ZoomResolutionChecker = ({ onClose, isVisible = false }) => {
    const { isOptimal } = useDisplayOptimality()

    if (!isVisible) return null

    return (
        <Overlay>
            <ModalContainer>
                <ModalHeader>
                    <Title>Display Settings Check</Title>
                    <CloseButton onClick={onClose}>
                        <MdClose size={20} />
                    </CloseButton>
                </ModalHeader>
                
                <ZoomResolutionContent />

                <ModalFooter>
                    <ActionButton onClick={onClose}>
                        {isOptimal ? 'Continue' : 'Close'}
                    </ActionButton>
                </ModalFooter>
            </ModalContainer>
        </Overlay>
    )
}

// Only keep the modal-related styled components
const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    padding: 20px;
`

const ModalContainer = styled.div`
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    max-width: 500px;
    width: 100%;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`

const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 24px 0 24px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 20px;
`

const Title = styled.h2`
    font-family: ${MobergFontFamily.HEADER};
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
`

const CloseButton = styled.button`
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    
    &:hover {
        background: #f5f5f5;
        color: #333;
    }
`

const ModalFooter = styled.div`
    padding: 20px 24px 24px 24px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: flex-end;
`

const ActionButton = styled.button`
    background: #0097EE;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 12px 24px;
    font-family: ${MobergFontFamily.HEADER};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
        background: #007fd1;
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
`

export default ZoomResolutionChecker